import { render, staticRenderFns } from "./NftIcon.vue?vue&type=template&id=cba6e2a8&scoped=true&"
import script from "./NftIcon.vue?vue&type=script&lang=js&"
export * from "./NftIcon.vue?vue&type=script&lang=js&"
import style0 from "./NftIcon.vue?vue&type=style&index=0&id=cba6e2a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba6e2a8",
  null
  
)

export default component.exports